import { render, staticRenderFns } from "./optional.vue?vue&type=template&id=c1994d8e&scoped=true&"
import script from "./optional.vue?vue&type=script&lang=js&"
export * from "./optional.vue?vue&type=script&lang=js&"
import style0 from "./optional.vue?vue&type=style&index=0&id=c1994d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1994d8e",
  null
  
)

export default component.exports